import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import ConfigProvider from 'ant-design-vue/es/config-provider'
import '@fontsource-variable/commissioner/full.css'
import '@fontsource-variable/fraunces/full.css'
import '@fontsource-variable/fraunces/full-italic.css'
import '../styles/press.css'

const pages = import.meta.glob('../pages/**/*.vue')

createInertiaApp({
  title: (title) => `${title} · No. 12 Press`,
  resolve: (name) => {
    const page = pages[`../pages/${name}.vue`]
    if (!page) throw new Error(`Page not found: ${name}`)
    return page().then((module) => module.default)
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(ConfigProvider, { theme: { token: { colorPrimary: '#8f312b', borderRadius: 0 } } }, () => h(App, props)) }).use(plugin).mount(el)
  },
})
